import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Stack,
  Button,
  Container,
  Typography,
} from '@mui/material';

import { ThemeProvider } from '@mui/material/styles';
import Theme from '../../components/Button';

// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
// mock
import EditarDespesaForm from '../FormsTemplates/Despesa/EditarDespesaForms';
import EditarDespesaPorTipoForm from '../FormsTemplates/Despesa/EditarDespesaPorTipoForms';

export default function AlterarDespesa() {
  
  const validaTipoComercio = localStorage.getItem(['tipo_comercio']);
  const tipoComercio = parseInt(validaTipoComercio, 10);
  const EditarDespesa = tipoComercio === 5 ? EditarDespesaPorTipoForm : EditarDespesaForm;

  return (
    <Page title="Despesa">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Alterar Despesa
          </Typography>
          <ThemeProvider theme={Theme}>
            <Button variant="contained" color="neutral" component={RouterLink} to="/despesa/consultar" startIcon={<Iconify icon="eva:arrow-back-fill" />}>
              Voltar
            </Button>
          </ThemeProvider>
        </Stack>
        <EditarDespesa/>    
      </Container>
    </Page>
  );
}
